import { reconfigButton } from '../../utility'
import { getFlow } from '../Form/Controls/flowUtility'

export const showContextMenu = (position = [0, 0], items) => {
	if (!items) return

	const menu = Ext.create('Ext.menu.Menu', {
		autoHide: false,
		scrollable: true,
		maxHeight: '80%',
		listeners: {
			hide: (menu) => {
				menu.destroy()
			},
			beforetofront: (menu) => {
				menu.setX(position[0] + menu.el.dom.clientWidth > Ext.Viewport.getWindowWidth() ? Math.max(position[0] - menu.el.dom.clientWidth, 0) : position[0])
				menu.setY(position[1] + menu.el.dom.clientHeight > Ext.Viewport.getWindowHeight() ? Math.max(position[1] - menu.el.dom.clientHeight, 0) : position[1])
			},
		},
		items: items,
	})

	menu.show()
	menu.focus()
	return menu
}


const truePromise = () => Promise.resolve(true)


export const handleItemContextMenu = (contextmenu, grid, record, e, that, checkGridData = truePromise) => {
	const genContextMenuItems = (contextmenu, record, grid, that, copy) => {
		const data = record.data
		const items = contextmenu.map((button) => {
			const { _button, icon, ui = 'action', disabled, hidden, name, text, handler, flowHandler, dataIndex, ...rest } = reconfigButton(button)
			const item = { text: Tyan.t(dataIndex ? data[dataIndex] : name && data[name] || _button, 'button') }
			handler && (item.handler = (...args) => handler(that, data, record, grid, copy, ...args))
			flowHandler && (item.handler = flowHandler)
			icon != undefined && (typeof icon === 'function' ? (item.iconCls = `x-fa fa-${icon(data, record, grid, copy)}`) : item.iconCls = `x-fa fa-${icon}`)
			const props = { ui, disabled, hidden, text }
			Object.keys(props).forEach(o => {
				props[o] !== undefined && (typeof props[o] === 'function' ? (item[o] = props[o](data, record, grid, copy)) : item[o] = props[o])
			})
			text && (item.text = Tyan.t(item.text, 'button'))
			return item
		})

		return items.find(o => !o.hidden) ? items : null
	}

	if (!contextmenu) return

	e.stopEvent && e.stopEvent()

	checkGridData([record.data.id]).then(
		r => {
			r ? Promise.resolve() : Promise.reject()
		}
	).then(
		() => Tyan.clipboard.read()
	).then(
		copy => {
			const { id } = record.data
			const refreshPage = that.refreshPage

			const buttons = contextmenu.filter(({ _flow }) => !_flow)

			Promise.all(
				contextmenu.filter(({ _flow }) => _flow).map(item => {
					const { _flow, onFinish, param } = item
					return getFlow({ flow: _flow, id, param, onFinish: onFinish || refreshPage,/* onClose, onFlowFinished */ })
				})
			).then(
				results => {
					return Promise.resolve(results.reduce((sum, { acts }) => {
						sum = sum.concat(acts.map(({ config }) => {
							config.flowHandler = config.handler
							delete config.handler
							return config
						}))
						return sum
					}, buttons))
				}
			).then(
				buttons => {
					if (buttons.length) {
						grid.getSelectable().getMode() === 'single' && grid.getSelection() != record && grid.setSelection(record)

						showContextMenu(e.getXY(), genContextMenuItems(buttons, record, grid, that, copy))
					}
				}
			)
		}
	).catch(r => undefined)
}


export const handleCommonContextMenu = (contextmenu, e) => {
	const genContextMenuItems = (contextmenu, copy) => {
		const items = contextmenu.map((button) => {
			const { _button, icon, ui = 'action', disabled, hidden, text, handler, flowHandler, ...rest } = reconfigButton(button)
			const item = { text: Tyan.t(name && data[name] || _button, 'menuItem') }
			// const item = {}
			handler && (item.handler = (...args) => handler(copy, ...args))
			flowHandler && (item.handler = flowHandler)
			icon != undefined && (typeof icon === 'function' ? (item.iconCls = `x-fa fa-${icon(copy)}`) : item.iconCls = `x-fa fa-${icon}`)
			const props = { ui, disabled, hidden, text }
			Object.keys(props).forEach(o => {
				props[o] !== undefined && (typeof props[o] === 'function' ? (item[o] = props[o](copy)) : item[o] = props[o])
			})
			return item
		})

		return items.find(o => !o.hidden) ? items : null
	}


	if (!contextmenu) return

	e.stopEvent && e.stopEvent()

	Tyan.clipboard.read().then(
		copy => {
			const buttons = contextmenu.filter(({ _flow }) => !_flow)

			Promise.all(
				contextmenu.filter(({ _flow }) => _flow).map(item => {
					const { _flow, id, onFinish, param } = item
					return getFlow({ flow: _flow, id, param, onFinish: onFinish,/* onClose, onFlowFinished */ })
				})
			).then(
				results => {
					return Promise.resolve(results.reduce((sum, { acts }) => {
						sum = sum.concat(acts.map(({ config }) => {
							config.flowHandler = config.handler
							delete config.handler
							return config
						}))
						return sum
					}, buttons))
				}
			).then(buttons => buttons.length && showContextMenu(e.getXY(), genContextMenuItems(buttons, copy)))
		}
	).catch(r => undefined)
}
